export default {
  SPIN: 'SPIN',
  'You are not eligible for free spins':
    'Only steam accounts with CSGO game and no VAC are eligible for free coins. Re-login to the site to update.',
  'It must be 24 hours since last roll': 'It must be 24 hours since last roll.',
};
